export function addDocument (state, { competitionId, document }) {
	const exsistingCompetitionIndex = state.competitions.findIndex(competition => competition.id === competitionId);

	if (exsistingCompetitionIndex >= 0) {
		return state.competitions[exsistingCompetitionIndex].documents.push(document);
	}
}
